import { ChangeEvent } from 'react';
import '../../styles/reusable/Checkbox.css';

interface CheckboxProps {
  label: string;
  name: string;
  checked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  disabled?: boolean;
  className?: string;
}

const Checkbox = ({
  label,
  name,
  checked,
  onChange,
  disabled = false,
  className = '',
}: CheckboxProps) => {
  return (
    <div className={`reusable-checkbox-group ${className}`}>
      <label className="reusable-checkbox-label">
        <input
          type="checkbox"
          name={name}
          checked={checked}
          onChange={onChange}
          disabled={disabled}
          className="reusable-checkbox-input"
        />
        <span className="checkbox-custom"></span>
        <span className="checkbox-text">{label}</span>
      </label>
    </div>
  );
};

export default Checkbox;
